import SearchEngineAdapter from 'Services/Adapters/SearchEngineBeta/SearchEngineAdapter';
import OpportunitiesStatus from 'Config/authenticated/OpportunitiesStatus';
import { v4 as uuidv4 } from 'uuid';
export default class OpportunityAdapter extends SearchEngineAdapter {
    /**
     * Define statically the class key
     * Allows to determine the type of class without instantiating it
     */
    static get _key() {
        return 'opportunity';
    }

    constructor(data = [], query = '') {
        super(data, query);
        this.key = OpportunityAdapter._key;
    }

    getStructure() {
        return {
            key: this.key,
            label: window.i18n.__('Opportunité'),
            count: 0,
            items: [],
            filters: ['opportunity'],
        };
    }

    formatItem(item) {
        return {
            id: item.object.id,
            name: this.checkFieldForQuery(item.name),
            ident: this.checkFieldForQuery(item.number),
            related: {
                type: item.related.type,
                name: this.checkFieldForQuery(item.related.name),
                last_name: this.checkFieldForQuery(item.related.last_name),
                first_name: this.checkFieldForQuery(item.related.first_name),
                link:
                    item.related.type === 'company'
                        ? `/companies/${item.related.id}`
                        : `/individuals/${item.related.id}`,
            },
            status: {
                id: item.status,
                label: OpportunitiesStatus[item.status].label,
            },
            amount: window.sellsyapp.config.globalProperties.$filters.numberFormatCurrency(
                item.amount,
            ),
            link: `/prospection/opportunities/${item.object.id}`,
            component: 'search-result-opportunity',
            uuid: uuidv4(),
        };
    }
}
